export default __webpack_public_path__ + "static/media/Avgle.34ca4fc0.png";